import { useContext } from 'react';
import { useIntl } from 'react-intl';
import { Link } from 'react-router-dom';
import { ServiceProps, ServicesProps } from '../../../../pages/ServicesPage';
import { ModelsService } from '../../../../services/ModelsService';
import { AppContext } from '../../../../state/AppContextProvider';
import { SanitizeHTML } from '../../../globals/SanitizeHTML';

/**
 * Service Breadcrumb
 * @param props
 * @returns
 */
interface BreadcrumbItem {
  label: string;
  link: string;
}

interface ServiceBreadcrumbProps extends ServiceProps, ServicesProps {}

const ServiceBreadcrumb: React.FC<ServiceBreadcrumbProps> = ({
  service,
  services,
}) => {
  const intl = useIntl();

  const { state } = useContext(AppContext);

  const servicesPath: BreadcrumbItem[] = ModelsService.getAncestors(
    service,
    services
  )
    .reverse()
    .map((s) => ({
      label: s.title.rendered,
      link: ModelsService.getServiceFullSlug(s),
    }));

  const items = [
    {
      label: intl.formatMessage({ id: 'Services' }),
      link: state.previousPath.startsWith('/services')
        ? state.previousPath
        : '/services/tabs/campus',
    },
  ].concat(servicesPath);

  // index of last item
  const last = items.length - 1;

  const Separator = () => <span className="mx-2">&gt;</span>;

  return (
    <ul className="flex text-gray-500 text-xs lg:text-base px-2">
      {items.map((item, idx) => {
        const isLast = idx === last;
        return (
          <li
            key={idx}
            className={
              'inline-flex items-center ' +
              (isLast ? '' : 'text-primary font-bold')
            }
          >
            <Link to={item.link}>
              <SanitizeHTML html={item.label} />
            </Link>
            {!isLast && <Separator />}
          </li>
        );
      })}
    </ul>
  );
};

export default ServiceBreadcrumb;
